import { render, staticRenderFns } from "./UsuarioCreate.vue?vue&type=template&id=5505618e&"
import script from "./UsuarioCreate.vue?vue&type=script&lang=js&"
export * from "./UsuarioCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports